import React, { useState } from "react"
import { TextArea} from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { sendFactoryComment } from "../../../redux/currentCase/thunks";
import { validateAddFactoryCommentData } from "../case/formValidationFunctions";
import { openModal } from "../../../redux/modal/modalSlice";
import { errorHandler } from "../../../commonFunctions/errorHandler";
import { getCommentByCaseId } from "../../../redux/contract/thunks";
import { getFactoryCasesByPlate } from "../../../redux/factoryCases/thunks";
import { selectContract } from "../../../redux/contract/selectors";
import { selectCurrentCase } from "../../../redux/currentCase/selectors";
import { PanelDialogue } from "../../common/PanelDialogue";

function AddFactoryCommentForm(props){
    const {showAddFactoryCommentForm, handleShowForms, setShowAddFactoryCommentForm, currentCaseId = null, processId, expedient, showArrow, anchorId, placement} = props;
    const [disabledActionButtons, setDisabledActionButtons] = useState(false)
    const dispatch = useDispatch();
    const contract = useSelector(selectContract);
    const caseLoadedInPanel = useSelector(selectCurrentCase)
    const anchorEl = document.getElementById(anchorId)

    const [formData, setFormData] = useState({
        comment: "",
    })

    async function handleSubmit(){
        const submitData = {...formData, processId: processId, expedient: expedient}
        setDisabledActionButtons(true);
        if(!validateAddFactoryCommentData(submitData, dispatch)){
            setDisabledActionButtons(false);
            return
        }

        try {

            await dispatch(sendFactoryComment({body: submitData}))
            
            const refreshCaseComments = currentCaseId || (caseLoadedInPanel.factoryProcessId === processId) // si el caso cargado en el panel tiene asignado el caso en fábrica que estamos comentando, refrescar vista de comentarios del caso

            if(refreshCaseComments){
                await dispatch(getCommentByCaseId({query: `?caseId=${caseLoadedInPanel.caseId}`}))
            }
            
            await dispatch(getFactoryCasesByPlate({query: `?plate=${contract.plate}`}))

            setFormData(
                {
                    comment: "",
                }
            )
        } catch (error) {
            dispatch(openModal(errorHandler(error)))
        } 
        finally{
            setDisabledActionButtons(false);
            setShowAddFactoryCommentForm(false)
        }
    }

    return(
        <PanelDialogue
            title={"Adicionar comentário fábrica"}
            anchorEl={anchorEl}
            placement={placement}
            showArrow={showArrow}
            flip={true}
            open={showAddFactoryCommentForm}
            submitFunction={handleSubmit}
            submitText={"Adicionar comentário fábrica"}
            cancelText={"Cancelar"}
            disableButtons={disabledActionButtons}
            cancelFunction={()=>handleShowForms("addFactoryComment")}
        >
                  <TextArea label="Comentário fábrica" labelMode="floating" height={150} value={formData.comment} onValueChanged={(e)=>setFormData(prevState=>({...prevState, comment: e.value}))}/>
        </PanelDialogue>
    )
}

export {AddFactoryCommentForm}